export const environment = {
  production: false,
  BASE_HREF: '/EEA/MEPA-eMonitor/'
};
